<script setup>
import { computed, watch } from 'vue';
import IEventItem from '@components/IEventItem/IEventItem.vue';
import IButton from '@components/IButton/IButton.vue';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';
import useSiteStore from '@vueApp/store/modules/site.js';
import EventsItemsEmpty from './EventsItemsEmpty.vue';
import EventItemsSkeleton from './EventItemsSkeleton.vue';

const store = useSiteStore();
store.searchSubscriptions();

const loadingData = computed(
  () => store.getSubscriptionsState.loading,
);

const showSubscriptions = computed(
  () => !!store.getSubscriptionsState.items.length
      && (!store.getSelectTypes.items.length || store.getSelectTypes.items.includes(2)),
);

watch(loadingData, () => (loadingData.value ? $('#js-overlay').show() : $('#js-overlay').hide()));
</script>

<template>
  <event-items-skeleton :is-data-loading="loadingData">
    <events-items-empty>
      <div v-if="showSubscriptions" class="mb-5">
        <span class="event-item__title">
          {{ translator.t("main", "Subscriptions") }}
        </span>
        <i-event-item
          v-for="event in store.getSubscriptionsState.items"
          :key="event.id"
          :event="event"
          :is-package="true"
          class="mb-3"
        />
        <div v-if="store.getSubscriptionsState.showLoadMore" class="d-flex justify-content-center">
          <i-button
            type="button"
            variant="primary"
            :on-click="store.loadMoreSubscriptions"
            :loading="store.getSubscriptionsState.loadingMore"
          >
            {{ translator.t("main", "More") }}
          </i-button>
        </div>
      </div>
    </events-items-empty>
  </event-items-skeleton>
</template>

<style lang="scss" scoped>
.event-item {
  &__title {
    position: relative;
    font-weight: 700;
    font-size: 30px;
    color: $dark-text;
    margin-bottom: 24px;
    margin-top: 28px;
    display: block;
  }

  &__title_small {
    content: '';
    position: absolute;
    bottom: 5px;
    left: 3px;
    font-weight: 700;
    font-size: 36px;
    color: rgba(0, 11, 77, 1);
  }

  @media (max-width: $screen-xs) {
    &__title {
      font-weight: 800;
      font-size: 24px;
      margin-bottom: 16px;
    }

    &__title_small {
      content: '';
      bottom: 3px;
      left: 2px;
      font-weight: 600;
      font-size: 20px;
    }
  }
}
</style>
